import React from 'react';
import { Input as FormInput } from 'formik-antd';

// TextArea component that prevents drag events from propagating
// Useful when TextArea is inside a draggable container (like sortable table rows)
const NoDragTextArea = (props) => {
    return (
        <FormInput.TextArea 
            {...props}
            onMouseDown={(e) => {
                e.stopPropagation();
                props.onMouseDown?.(e);
            }}
            onPointerDown={(e) => {
                e.stopPropagation();
                props.onPointerDown?.(e);
            }}
        />
    );
};

export default NoDragTextArea;